module.exports = "/_next/static/images/error-01-b0f7febf79bec3358a228108bf8b2c72.svg";